import { Box, Button, Text } from '@chakra-ui/react'
import { Logo } from 'components/atoms'
import React from 'react'
import { Link as LinkRouter } from 'react-router-dom'
import { STATUS } from './constants'
import { ErrorProps } from './interfaces'

export const Error: React.FC<ErrorProps> = ({ status, description }) => {
    const message = description || STATUS[status]

    return (
        <>
            <Box
                data-testid="error-wrapper"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                gap={14}
            >
                <Box>
                    <Logo maxW={187} />
                </Box>
                <Box
                    textAlign="center"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    gap={6}
                >
                    <Text color="primary.500" fontWeight="700" fontSize={60}>
                        {status}
                    </Text>
                    {message && (
                        <Text
                            whiteSpace="pre"
                            color="black"
                            fontWeight="700"
                            fontSize={36}
                        >
                            {message}
                        </Text>
                    )}
                </Box>
                <Button
                    data-testid="error-button"
                    as={LinkRouter}
                    to="/"
                    colorScheme="primary"
                    size="md"
                >
                    Voltar para o início
                </Button>
            </Box>
        </>
    )
}
